/**
 * One calendar row in the picker — README §7. No colour dot (deferred, no
 * per-calendar colour data available in one API call) and no event count
 * (deferred, no aggregate data source — leave the slot empty, never a
 * fake zero). "Primary calendar" is derived by comparing the calendar id
 * to the integration's own account address, not a field the provider
 * returns — see project notes on the "Shared with you" line being tabled.
 */
import React, { useCallback } from "react";
import Checkbox from "../../theme/untitled/Checkbox/Checkbox";
import styles from "./CalendarPickerList.module.scss";

const CalendarPickerRow = ({ calendar, isPrimary, checked, onChange }) => {
  const handleChange = useCallback(
    (e) => onChange(calendar.id, e.target.checked),
    [onChange, calendar.id]
  );

  // The checkbox and the text are each already their own <label> (native
  // click-to-toggle), so only handle clicks that land outside both of
  // those — e.g. the row's padding/gap — to avoid toggling twice.
  const handleRowClick = useCallback(
    (e) => {
      if (e.target.closest("label")) {
        return;
      }
      onChange(calendar.id, !checked);
    },
    [onChange, calendar.id, checked]
  );

  return (
    <li className={styles.row} onClick={handleRowClick}>
      <Checkbox
        size="md"
        className={styles.rowCheckbox}
        id={`calendar-${calendar.id}`}
        checked={checked}
        onChange={handleChange}
      />
      <label htmlFor={`calendar-${calendar.id}`} className={styles.rowText}>
        <span className={styles.rowName}>{calendar.label}</span>
        {isPrimary && (
          <span className={styles.rowSecondary}>Primary calendar</span>
        )}
      </label>
    </li>
  );
};

export default CalendarPickerRow;
